import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';
import posthog from 'posthog-js';
import useStyles from '../styles';
import { getBleWebViewUrl } from '../state/selectors';
import { showHelp } from '../state/actions';
import { useAppDispatch, useAppSelector } from '../state/store';

interface MainWrapperProps {
  routeComponent: JSX.Element;
  helmetTitle: string;
}

function MainWrapper({ routeComponent, helmetTitle }: MainWrapperProps): JSX.Element {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const bleWebViewUrl = useAppSelector(getBleWebViewUrl);

  posthog.capture('$pageview');

  useEffect(() => {
    if (bleWebViewUrl) {
      navigate(bleWebViewUrl);
      dispatch(showHelp(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bleWebViewUrl]);

  return (
    <main className={classes.mainContent}>
      <Helmet defaultTitle={helmetTitle} />
      {routeComponent}
    </main>
  );
}

export default MainWrapper;
